import { driver } from "driver.js";
import "driver.js/dist/driver.css";

const TOUR_I18N = {
  it: {
    next: "Avanti →", prev: "← Indietro", done: "Fine", progress: "{{current}} di {{total}}",
    steps: [
      ["Dashboard", "Panoramica in tempo reale: KPI seriali, produzione mensile, alert scadenze automezzi e giacenze basse."],
      ["Magazzino Generale", "Tutti i seriali (ONT, modem, decoder) caricati e disponibili. Filtri per stato: in magazzino, in viaggio, installati."],
      ["Magazzino Viaggiante/Tecnici", "I seriali, l'attrezzatura e i materiali assegnati a ogni tecnico. Da qui generi la bolla di consegna DDT firmabile."],
      ["Automezzi", "Parco mezzi con documenti (libretto, assicurazione, bollo, revisione) e alert sulle scadenze."],
      ["Pianificazione (Assegnazioni Impianti)", "Carichi il file Excel giornaliero e il sistema assegna automaticamente le attività ai tecnici. Scarica il template dal pulsante verde."],
      ["Tecnici & Utenti", "Crea utenti con i loro ruoli. Imposta meta produzione mensile e sconti personalizzati per ogni tecnico."],
      ["Committenti & Listini", "Anagrafica dei clienti (FiberCop, OpenFiber, ecc.) con listini personalizzati che alimentano lavorazioni e BEF."],
      ["Lavorazioni", "Qui inserisci gli impianti chiusi positivi: totale € entra in produzione del mese sia del tecnico che dell'azienda."],
      ["BEF / Estrazioni", "A fine mese generi il BEF (Bollettino Estrazione Forfait) per ogni tecnico e committente, in PDF con logo."],
      ["Preventivi", "Emetti preventivi per clienti finali con la tua intestazione, numerazione automatica e PDF pronto da inviare."],
      ["Performance (KPI Tecnici)", "Confronta assegnati vs chiusi positivi per ogni tecnico. Grafico giornaliero e percentuale KPI."],
      ["Manuale d'uso", "Guida completa scritta con schermate di ogni sezione. Scaricabile anche in PDF."],
      ["Tutto pronto!", "Puoi riavviare questo tour in qualsiasi momento dal Manuale d'uso o dal pulsante 'Guidami' sulla dashboard."],
    ],
  },
  en: {
    next: "Next →", prev: "← Back", done: "Done", progress: "{{current}} of {{total}}",
    steps: [
      ["Dashboard", "Real-time overview: serial KPIs, monthly production, vehicle expiration alerts and low stock warnings."],
      ["General Warehouse", "All serials (ONT, modems, decoders) loaded and available. Filter by status: in warehouse, in transit, installed."],
      ["Traveling Warehouse/Technicians", "Serials, equipment and materials assigned to each technician. From here you generate the signable delivery note (DDT)."],
      ["Vehicles", "Fleet with documents (registration, insurance, road tax, inspection) and expiration alerts."],
      ["Planning (Job Assignments)", "Upload the daily Excel file and the system automatically assigns jobs to technicians. Download the template from the green button."],
      ["Technicians & Users", "Create users with their roles. Set monthly production targets and custom discounts for each technician."],
      ["Clients & Price Lists", "Client master data (FiberCop, OpenFiber, etc.) with custom price lists that feed work orders and BEF."],
      ["Work Orders", "Enter closed-positive installations here: € total goes into the monthly production of both the technician and the company."],
      ["BEF / Extractions", "At month end generate the BEF (Bollettino Estrazione Forfait) for each technician and client, as a branded PDF."],
      ["Quotes", "Issue quotes for end customers with your letterhead, automatic numbering and PDF ready to send."],
      ["Performance (Technician KPIs)", "Compare assigned vs positively closed for each technician. Daily chart and KPI percentage."],
      ["User Manual", "Complete written guide with screenshots of every section. Also downloadable as PDF."],
      ["All set!", "You can restart this tour anytime from the User Manual or the 'Guide me' button on the dashboard."],
    ],
  },
  fr: {
    next: "Suivant →", prev: "← Retour", done: "Terminé", progress: "{{current}} sur {{total}}",
    steps: [
      ["Tableau de bord", "Vue en temps réel : KPI numéros de série, production mensuelle, alertes d'échéance véhicules et stocks bas."],
      ["Entrepôt général", "Tous les numéros de série (ONT, modems, décodeurs) chargés et disponibles. Filtres par statut : en entrepôt, en route, installés."],
      ["Entrepôt itinérant / Techniciens", "Numéros de série, équipement et matériaux affectés à chaque technicien. D'ici vous générez le bon de livraison signable (DDT)."],
      ["Véhicules", "Parc de véhicules avec documents (carte grise, assurance, contrôle technique) et alertes d'échéance."],
      ["Planification (Affectations d'installations)", "Chargez le fichier Excel quotidien et le système affecte automatiquement les interventions aux techniciens. Téléchargez le modèle depuis le bouton vert."],
      ["Techniciens & Utilisateurs", "Créez des utilisateurs avec leurs rôles. Définissez objectifs mensuels et remises personnalisées pour chaque technicien."],
      ["Donneurs d'ordre & Listes de prix", "Fiches clients (FiberCop, OpenFiber, etc.) avec listes de prix personnalisées qui alimentent interventions et BEF."],
      ["Interventions", "Saisissez ici les installations clôturées positives : le total € entre dans la production du mois du technicien et de l'entreprise."],
      ["BEF / Extractions", "En fin de mois, générez le BEF (Bollettino Estrazione Forfait) pour chaque technicien et donneur d'ordre, en PDF avec logo."],
      ["Devis", "Émettez des devis pour clients finaux avec votre en-tête, numérotation automatique et PDF prêt à envoyer."],
      ["Performance (KPI Techniciens)", "Comparez affectés vs clôturés positifs pour chaque technicien. Graphique quotidien et pourcentage KPI."],
      ["Manuel d'utilisation", "Guide complet écrit avec captures d'écran de chaque section. Téléchargeable aussi en PDF."],
      ["Tout est prêt !", "Vous pouvez relancer ce tour à tout moment depuis le Manuel d'utilisation ou le bouton « Guidez-moi » du tableau de bord."],
    ],
  },
};

const NAV_TESTIDS = [
  "nav-dashboard", "nav-magazzino", "nav-viaggiante", "nav-automezzi",
  "nav-assegnazioni", "nav-tecnici", "nav-committenti", "nav-lavorazioni",
  "nav-bef", "nav-preventivi", "nav-performance", "nav-manuale", null,
];

export function startAppTour({ onEnd, lang } = {}) {
  const chosenLang = (lang || (typeof window !== "undefined" && window.localStorage?.getItem("evosoft_lang")) || "it").slice(0, 2);
  const i18n = TOUR_I18N[chosenLang] || TOUR_I18N.it;
  const d = driver({
    showProgress: true,
    animate: true,
    smoothScroll: true,
    allowClose: true,
    nextBtnText: i18n.next,
    prevBtnText: i18n.prev,
    doneBtnText: i18n.done,
    progressText: i18n.progress,
    onDestroyed: () => { if (onEnd) onEnd(); },
    steps: i18n.steps.map(([title, description], idx) => ({
      element: NAV_TESTIDS[idx] ? `[data-testid="${NAV_TESTIDS[idx]}"]` : undefined,
      popover: { title, description },
    })),
  });
  d.drive();
  return d;
}
